import './testimonials.js';
import './map.js';
import './form-thank-you.js';
import './leave-review-tab';
import './hero-slider';
import './buttenders';
window.addEventListener("DOMContentLoaded", () => {

    document.querySelector(".hamburger").onclick = function() {
        document.querySelector("body").classList.toggle("menu-open");
    };

    AOS.init({ duration: 600, anchorPlacement: 'top-bottom' });
    if(document.querySelector('nav.main .hamburger')){
        document.querySelector('nav.main .hamburger').addEventListener('click', function(e) {
            document.querySelector('nav.mobile').classList.add('open');
        })
        document.querySelector('nav.mobile .close').addEventListener('click', function(e) {
            document.querySelector('nav.mobile').classList.remove('open');
        })
    }
    

    // Nav location indicators
    let url = window.location.href.split('/');
    let page = url[url.length - 1];
    // active for shop link
    if(page.localeCompare('store') == 0 || page.localeCompare('shop') == 0){
        let shop = document.querySelectorAll(`.links [href='https://www.greenlightspokane.com/online']`);
        if (shop) {
            for (let i = 0 ; i < shop.length ; i++) {
                shop[i].classList.add('active');
            }
        }
    }
    let link = document.querySelectorAll(`.links [href='/${page}']`);
    if (link) {
        for (let i = 0 ; i < link.length ; i++) {
            link[i].classList.add('active');
        }
    }

    // Location Cookie
    let locations = document.querySelectorAll('.logo .locations p');
    let mobilelocations = document.querySelectorAll('nav.mobile p');
    for (let i = 0 ; i < locations.length ; i++) {
        locations[i].addEventListener('click', function(e) {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            document.cookie = `location=${locations[i].innerText}; path=/; expires=${tomorrow};`;
            window.location.reload();
        })
    }
    for (let i = 0 ; i < mobilelocations.length ; i++) {
        mobilelocations[i].addEventListener('click', function(e) {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            document.cookie = `location=${mobilelocations[i].innerText}; path=/; expires=${tomorrow};`;
            window.location.reload();
        })
    }
    
    // Age verification popup
    let cookies = document.cookie.split('; ');
    let popup = document.querySelector('.popup-container');
    if (!cookies.includes('ageVerified=true')) /* MAKE SURE TO REPLACE THIS WHEN GOING LIVE */ {
        popup.classList.remove('hide');
    }
    
    let buttons = popup.querySelectorAll('.buttons .btn');
    for (let i = 0 ; i < buttons.length ; i++) {
        buttons[i].addEventListener('click', function(e) {
            e.preventDefault();
            if (buttons[i].classList.contains('secondary')) {
                window.location.href = 'https://www.google.com/';
            }
            else {
                popup.classList.add('hide');
                document.cookie = 'ageVerified=true';
            }
        })
    }

    // Announcement Bar
    let announcements = document.querySelectorAll('.announcement');
    announcements.forEach(announcement => {
        let start = Date.parse(announcement.dataset.start);
        let end = Date.parse(announcement.dataset.end);
        let today = Date.parse(new Date());
        
        if (today > start && today < end) {
            announcement.classList.remove('hide');
        }
    })

    // Reviews popout
    let review_popout = document.querySelector('.review-popout');
    if (review_popout) {
        review_popout.addEventListener('click', function(e) {
            review_popout.classList.add('hide-2');
        })
    }


    let form = document.querySelector('form.contact');

    if (form) {

        form.addEventListener('submit', ev => {
            ev.preventDefault();
            let inputs = form.querySelectorAll('input, textarea');
            let submit = form.querySelector('input[type="submit"]');

            let request = new XMLHttpRequest();
            let form_data = new FormData(form);
            request.open('POST', 'https://inform.prcr8.com/info@greenlightspokane.com')

            submit.value = 'Sending...';
            request.send(form_data);
            request.addEventListener('load', ev => {
                submit.value = "Sent!";
                inputs.forEach(inp => inp.setAttribute('disabled', true));
            });
        });
    }

    let reward_phone = document.getElementById('reward_phone');
    if(reward_phone){
    reward_phone.addEventListener('submit', ev => {

        let inputs = reward_phone.querySelectorAll('input, textarea');
        let submit = reward_phone.querySelector('input[type="submit"]');

        console.log(ev);
        ev.preventDefault();
        submit.value = 'Sending...';
        var oReq = new XMLHttpRequest();
        oReq.open("POST", "/wp-json/propaganda/v1/sign_up");
        let form_data = new FormData();
        form_data.append('customer_phone', reward_phone.querySelector('[name="phone"]').value);
        form_data.append('customer_name', reward_phone.querySelector('[name="name"]').value);
        oReq.send(form_data);
        oReq.addEventListener('load', ev => {
            console.log(ev);
            submit.value = "Sent!";
            inputs.forEach(inp => inp.setAttribute('disabled', true));


            let info = JSON.parse(ev.target.responseText);
            console.log(info);
            document.querySelector('.signup_modal').classList.remove('hide');
            document.querySelector('.signup_modal .info').innerText = info.info;
        });
    });
    }
    let signup = document.querySelector('.signup_modal .btn');
    if (signup) {
        signup.addEventListener('click', ev => {
            document.querySelector('.signup_modal').classList.add('hide');
        });
    }

    //join our team
    let joinOurTeam = document.querySelector('.join-our-team');

    if(joinOurTeam){
        let form = joinOurTeam.querySelector('form');
        joinOurTeam.querySelector('.close-btn').addEventListener('click',()=>{
            joinOurTeam.classList.add('hide')
        })
        form.addEventListener('submit', ev => {
            // ev.preventDefault();
            let inputs = form.querySelectorAll('input[type="email"], input[type="file"]');
            let submit = form.querySelector('input[type="submit"]');

            // let request = new XMLHttpRequest();
            // let form_data = new FormData(form);
            // request.open('POST', 'https://inform.prcr8.com/tam@propagandacreative.com') 

            // submit.value = 'Sending...';
            // request.send(form_data);
            // request.addEventListener('load', ev => {
            //     submit.value = "Sent!";
            //     inputs.forEach(inp => inp.setAttribute('disabled', true));
            // });

            submit.value = "Submitted!";
            submit.classList.add('disabled');
        });
    }
    let joinBtn = document.querySelectorAll('.join-our-team-btn');
    joinBtn.forEach(element => {
        element.addEventListener('click', ()=>{
            document.querySelector('.join-our-team').classList.remove('hide');
        })
    });


    //review-popup
    let review_popup = document.querySelector('.review-popup')
    if(review_popup){
        review_popup.querySelector('.close-btn').addEventListener('click',()=>{
            review_popup.classList.add('hide')
        })
    }
    // review-popup-btn
    let review_btn = document.querySelector('#review-popup-btn')
    if(review_btn){
        review_btn.addEventListener('click',()=>{
            document.querySelector('.review-popup').classList.remove('hide')
        })
    }
    


    //highlight current deal
    // const weekday= ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    
    // let current_date = new Date();
    // current_date = current_date.getDay();
    // let dailydeals = document.querySelectorAll('.card.daily-deal');
    // dailydeals.forEach(deal=>{
    //     deal.classList.remove('highlight')
    //     if(deal.dataset.day == weekday[current_date]){
    //         deal.classList.add('highlight');
    //     }
    // })

    //slider
    // const slider = document.querySelector('.slider');
    // if(slider){
    //     let slidetrack = slider.querySelector('.slide-track');
    //     let slideWidth = slidetrack.querySelector('.slide').getBoundingClientRect().width;
    //     let numSlides = slidetrack.querySelectorAll('.slide').length;
    //     let pos = 0;
    //     let old_pos = 0;
    //     let translate = 0;

    //     let slidehandle = setInterval(forward, 10000);

    //     slidetrack.addEventListener('touchstart', onTouchStart);
    //     slidetrack.addEventListener('touchend', onMouseUp);
    //     slidetrack.addEventListener('touchmove', onTouchMove);

    //     slider.addEventListener('mousedown', onMouseDown);
    //     slider.addEventListener('mouseup', onMouseUp);
    //     slider.addEventListener('mouseleave', onMouseUp);
    //     slider.addEventListener('mousemove', onMouseMove);
    //     let deltaX = 0;
    //     let prevX = 0;
    //     let mouseMove = false;
    //     let mouseUp = false;
    //     let original_translateX = 0;
    //     function onTouchStart(e){
    //         mouseMove = true;
    //         original_translateX = slidetrack.getAttribute('style').split('translateX(')[1].split('px')[0];
    //         prevX = e.touches[0].clientX;
    //     }
    //     function onMouseDown(e){
    //         mouseMove = true;
    //         // console.log('down');
    //         original_translateX = slidetrack.getAttribute('style').split('translateX(')[1].split('px')[0];
    //         prevX = e.clientX;
    //     }
    //     function onMouseUp(){
    //         if(mouseMove){
    //             mouseMove = false;
    //             mouseUp = true;
    //             // console.log('up');
    //             if(deltaX > 0){//move left
    //                 // console.log('move left')
    //                 back();
    //                 clearInterval(slidehandle);
    //                 slidehandle = setInterval(forward, 10000);

    //             } else{
    //                 // console.log('move right')
    //                 forward();
    //                 clearInterval(slidehandle);
    //                 slidehandle = setInterval(forward, 10000);
    //             }
    //         }
    //     }
        
    //     function onMouseMove(e){
    //         if(mouseMove){
    //             deltaX = e.clientX - prevX;
    //             // console.log('move')
    //             let trans = parseInt(original_translateX) + parseInt(deltaX);
    //             slidetrack.style.transform = `translateX(${trans}px)`;
    //             slidetrack.style.transition = "none";
    //             clearInterval(slidehandle);
    //         }
    //     }
    //     function onTouchMove(e){
    //         if(mouseMove){
    //             deltaX = e.touches[0].clientX - prevX;
    //             // console.log('move')
    //             let trans = parseInt(original_translateX) + parseInt(deltaX);
    //             slidetrack.style.transform = `translateX(${trans}px)`;
    //             slidetrack.style.transition = "none";
    //             clearInterval(slidehandle);
    //         }
    //     }
    //     function back(e) {
    //         old_pos = pos;
    //         pos = ((pos - 1) + (numSlides - 2)) % (numSlides - 2);
    //         translate = -1 * ((pos * slideWidth) + (pos * 30));
    //         if (pos == (numSlides - 3)) { // Takes care of the overlap, makes the slider look seamless
    //             if(!mouseUp){
    //                 slidetrack.classList.add('reset');
                    
    //                 slidetrack.setAttribute('style', `transform: translateX(${translate}px);`)
    //                 pos = ((pos - 1) + (numSlides - 2)) % (numSlides - 2);
    //                 translate = -1 * ((pos * slideWidth) + (pos * 30));
    //                 setTimeout(function(e) {
    //                     slidetrack.classList.remove('reset');
    //                     slidetrack.setAttribute('style', `transform: translateX(${translate}px);`)
    //                 }, 50);
    //             }else{
    //                 mouseUp = false;
    //                 slidetrack.setAttribute('style', `transform: translateX(${original_translateX}px);`)
    //                 pos = old_pos;
    //             }
    //         }
    //         else {
    //             slidetrack.setAttribute('style', `transform: translateX(${translate}px);`)
    //         }
    //     }
        
    //     function forward(e) {
    //         old_pos = pos;
    //         pos = (pos + 1) % (numSlides - 2);
    //         translate = -1 * ((pos * slideWidth) + (pos * 30));
    //         if (translate == 0) { // Takes care of the overlap, makes the slider look seamless
    //             // console.log('reset')
    //             if(!mouseUp){
    //                 slidetrack.classList.add('reset');
    //                 slidetrack.setAttribute('style', `transform: translateX(${translate}px);`)
    //                 pos = (pos + 1) % (numSlides - 2);
    //                 translate = -1 * ((pos * slideWidth) + (pos * 30));
    //                 setTimeout(function(e) {
    //                     slidetrack.classList.remove('reset');
    //                     slidetrack.setAttribute('style', `transform: translateX(${translate}px);`)
    //                 }, 50);
    //             }else{
    //                 mouseUp = false;
    //                 slidetrack.setAttribute('style', `transform: translateX(${original_translateX}px);`)
    //                 pos = old_pos;
    //             }
                
    //         }
    //         else {
    //             slidetrack.setAttribute('style', `transform: translateX(${translate}px);`)
    //         }
            
    //     }
    //     window.addEventListener('resize', function(e) {
    //         slideWidth = slidetrack.querySelector('.slide').getBoundingClientRect().width;
    //         translate = -1 * ((pos * slideWidth) + (pos * 30));
    //         slidetrack.setAttribute('style', `transform: translateX(${translate}px);`);
    //     })
        
    // }
});
